import { z } from 'zod';

export const orderAreaSchema = z.enum(['domestic', 'cross_border', 'port']);
/**
 * - `domestic` = means within the same country
 * - `cross_border` = means across 2 countries
 * - `port` = means within the same country but from the port
 */
export type OrderArea = z.infer<typeof orderAreaSchema>;

export const orderModelSchema = z.enum(['FTL', 'PTL', 'LTL']);

/**
 * - `FTL` = Full Truck Load
 * - `PTL` = Partial Truck Load
 * - `LTL` = Less than Truck Load
 *
 * later on we can add 'on_demand_delivery' 'ride'
 *
 * for more info see this pic {@link https://images.app.goo.gl/dbrJw96RRNh9omYEA}
 */
export type OrderModel = z.infer<typeof orderModelSchema>;
